import type { ReactNode } from 'react'
import { ToastContext, useToastState } from '@/hooks/useToast'
import { ToastContainer } from './Toast'

/**
 * ToastProvider Component
 * Provides global toast context and renders the ToastContainer.
 * Wrap your app with this provider to enable useToast() everywhere.
 */
export function ToastProvider({ children }: { children: ReactNode }) {
  const toastState = useToastState()

  return (
    <ToastContext.Provider value={toastState}>
      {children}
      <ToastContainer toasts={toastState.toasts} onDismiss={toastState.dismiss} />
    </ToastContext.Provider>
  )
}
